/**
 * Symbols for the currencies Tree Tier actually bills in. Matches the invoice generator's `Money()`,
 * so the price on the page and the figure on the receipt use the same mark.
 *
 * Every customer outside India is billed in **US dollars** — there is one non-INR plan and no local
 * currencies. "$" is therefore always US dollars here, never NZD, AUD or CAD. That ambiguity is
 * carried by the currency *label* rather than the symbol: `currencyLabel` spells out
 * "US Dollars (USD)", and the pricing copy states it beside every amount.
 */
const CURRENCY_SYMBOLS: Record<string, string> = {
	INR: "₹",
	USD: "$"
};

/**
 * Symbol for a plan currency. Unknown currencies fall back to their ISO code so an international
 * visitor always sees what their card will be charged in, never a bare number.
 */
export const currencySymbol = (currency: string): string => {
	const code = currency.toUpperCase();

	return CURRENCY_SYMBOLS[code] ?? `${code} `;
};

/** Whole amounts print without decimals; anything with paise keeps two. */
export const formatAmount = (amount: number): string => (amount % 1 === 0 ? amount.toFixed(0) : amount.toFixed(2));

/** An amount with its currency symbol, e.g. "₹59". */
export const formatPrice = (amount: number, currency: string): string =>
	`${currencySymbol(currency)}${formatAmount(amount)}`;
